
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"18","height":"24","viewBox":"0 0 21.86 27.662","fill":"#FFF"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Grupo 7072"}},[_c('path',{attrs:{"data-name":"Unión 323","d":"M12.092 24.954H.489A.489.489 0 010 24.465V.489A.489.489 0 01.489 0H11.85a.491.491 0 01.342.14l6.618 6.47a.49.49 0 01.147.35v10.831a5.2 5.2 0 11-6.864 7.163zm.343-2.494a4.224 4.224 0 104.223-4.223 4.228 4.228 0 00-4.224 4.223zM.979 23.975h10.657a5.248 5.248 0 016.341-6.591v-9.91h-6.136a.49.49 0 01-.49-.489V.979H.979zM12.331 6.5h4.939l-4.939-4.846z"}}),_c('path',{attrs:{"data-name":"Unión 321","d":"M8.951 18.846v-2.694H6.294a.49.49 0 010-.979h2.657v-2.696a.49.49 0 01.979 0v2.695h2.733a.49.49 0 010 .979H9.93v2.695a.49.49 0 01-.979 0z"}}),_c('g',{attrs:{"data-name":"Grupo 7071"}},[_c('path',{attrs:{"data-name":"Unión 324","d":"M16.167 24.214v-2.216l-.933.83a.49.49 0 01-.651-.731l1.753-1.559a.489.489 0 01.651 0l1.743 1.551a.49.49 0 01.041.691l-.02.021a.49.49 0 01-.672.019l-.933-.83v2.224a.49.49 0 01-.979 0z"}})])])])
          )
        }
      }
    